import { Flex, Spinner, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { useToast } from "../../../components";
import { copy } from "../../../utils/clipboard";
import Modal from "../../components/Modal/Modal";
import {
  CandidateRediscoveryProspect,
  useCandidateRediscoveryProspectEmailLazyQuery,
} from "../../graphql";

interface ProspectEmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  prospect: CandidateRediscoveryProspect | null;
  positionId: string;
}

const ProspectEmailModal: React.FC<ProspectEmailModalProps> = ({
  isOpen,
  onClose,
  prospect,
  positionId,
}) => {
  const [loading, setLoading] = useState(false);
  const [emailCopy, setEmailCopy] = useState("");
  const toast = useToast();

  const [fetchEmailCopy] = useCandidateRediscoveryProspectEmailLazyQuery();

  useEffect(() => {
    if (!prospect) return;
    if (isOpen) {
      setLoading(true);
      setEmailCopy("");
      fetchEmailCopy({
        variables: {
          candidateId: prospect.candidateId,
          positionId,
        },
        onCompleted: (data) => {
          setEmailCopy(data?.candidateRediscoveryProspectEmail || "");
          setLoading(false);
        },
        onError: (error) => {
          setEmailCopy(
            "Unable to generate email at this time. Please try again later."
          );
          setLoading(false);
          toast({
            title: "Error",
            description: error.message,
            status: "error",
          });
        },
      });
    }
  }, [prospect, isOpen, positionId]);

  const handleCopy = (): void => {
    copy(emailCopy);
    toast({
      title: "Copied!",
      description: "The email text has been copied to your clipboard.",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerText="Generate re-engagement message"
      completeButtonText="Copy to clipboard"
      cancelButtonText="Cancel"
      onComplete={handleCopy}
      isLoading={loading}
      completeButtonDisabled={!emailCopy || loading}
      modalProps={{ size: "xl" }}
    >
      {loading ? (
        <Flex align="center" justify="center" minHeight="100px">
          <Spinner size="lg" />
        </Flex>
      ) : (
        <Text fontSize="md" fontWeight="400" color="gray.800">
          {emailCopy}
        </Text>
      )}
    </Modal>
  );
};

export default ProspectEmailModal;
